export default function LibraryResultBanner({
  count,
  queryLabel,
  actionLabel,
  onAction,
}) {
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onAction();
    }
  };

  return (
    <div className="clear-search">
      <div
        className="clear-search-button"
        role="button"
        tabIndex={0}
        onClick={onAction}
        onKeyDown={handleKeyDown}
      >
        <h3>{count} results for:</h3>
        <h3> {queryLabel}</h3>
        <h4 className="clear-text">{actionLabel}</h4>
      </div>
    </div>
  );
}
